(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cargo-bike-card-grid"] && !Shopify.designMode) return;
  try {
    
  function initializeCargoBikeGrids(root) {
    root.querySelectorAll('[data-cargo-bike-grid]').forEach((grid) => {
      if (grid.dataset.initialized === 'true') return;
      grid.dataset.initialized = 'true';

      grid.querySelectorAll('[data-bike-swatch]').forEach((swatch) => {
        swatch.addEventListener('click', () => {
          const card = swatch.closest('.cargo-bike-card');
          const image = card.querySelector('.cargo-bike-card__image');
          const imageUrl = swatch.dataset.image;
          const variantUrl = swatch.dataset.variantUrl;

          card.querySelectorAll('[data-bike-swatch]').forEach((button) => {
            const isActive = button === swatch;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-pressed', String(isActive));
          });

          if (image && imageUrl) {
            image.src = imageUrl;
            image.removeAttribute('srcset');
          }

          if (variantUrl) {
            card.querySelectorAll('[data-card-product-link]').forEach((link) => {
              link.href = variantUrl;
            });
          }
        });
      });
    });
  }

  initializeCargoBikeGrids(document);
  document.addEventListener('shopify:section:load', (event) => initializeCargoBikeGrids(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image_text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeVideo(wrapper) {
      if (wrapper.dataset.videoInitialized === 'true') return;
      wrapper.dataset.videoInitialized = 'true';

      var video = wrapper.querySelector('video');
      var iframe = wrapper.querySelector('iframe[data-video-src]');
      var shouldAutoplay = wrapper.dataset.videoAutoplay === 'true';
      var playButton = wrapper.querySelector('[data-image-text-play]');

      function syncPlayButton() {
        if (playButton && video) {
          playButton.hidden = !video.paused && !video.ended;
        }
      }

      if (video && playButton) {
        playButton.addEventListener('click', function () {
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {
              playButton.hidden = false;
            });
          }
        });
        video.addEventListener('play', syncPlayButton);
        video.addEventListener('pause', syncPlayButton);
        video.addEventListener('ended', syncPlayButton);
        syncPlayButton();
      }

      function activate() {
        if (iframe && !iframe.getAttribute('src')) {
          iframe.setAttribute('src', iframe.dataset.videoSrc);
        }
        if (video && shouldAutoplay) {
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
        }
      }

      function deactivate() {
        if (video) video.pause();
        if (iframe && iframe.getAttribute('src')) iframe.removeAttribute('src');
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) activate();
            else deactivate();
          });
        }, { rootMargin: '200px 0px' });
        observer.observe(wrapper);
      } else {
        activate();
      }
    }

    function initializeAll(root) {
      root.querySelectorAll('[data-image-text-video]').forEach(initializeVideo);
    }

    initializeAll(document);
    document.addEventListener('shopify:section:load', function (event) {
      initializeAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
